/**
 * A TipTap/ProseMirror doc with a single empty paragraph — the blank value for
 * comment editors. ProseMirror won't auto-fill an empty content array, so the
 * seeded paragraph gives the editor a textblock to mark as empty.
 */
export const EMPTY_DOC: Record<string, unknown> = {
  type: 'doc',
  content: [{ type: 'paragraph' }],
};
